import { render, staticRenderFns } from "./BaseImgButton.vue?vue&type=template&id=3c5ec477&"
import script from "./BaseImgButton.vue?vue&type=script&lang=js&"
export * from "./BaseImgButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports